import {html} from '@isceco/widget-library2/external/lit'

export default class ImportResultRemarksCell {
  render(i18n, cell, row) {
    if (cell) {
      return html`
        <div class="remarks">${this._formatRemarks(cell)}</div>
      `
    } else {
      return html``
    }
  }

  _formatRemarks = remarks => {
    if (remarks.length > 1) {
      return html`
        <ul>
          ${remarks.map(remark => html`<li>${remark}</li>`)}
        </ul>
        `
    } else {
      return remarks.map(remark => html`<span>${remark}</span>`)
    }
  }
}
